'use strict';

export function authInterceptor($rootScope, $q, $cookies, $injector, Util) {
  var state;
  return {
    // Add authorization token to headers
    request(config) {
      config.headers = config.headers || {};
      const token = $cookies.get('token');

      // Skip processing for template requests and external resources
      const isTemplate = config.url && (
        config.url.includes('uib/template/')
        || config.url.includes('.html') && !config.url.startsWith('/api')
        || config.url.startsWith('http://')
        || config.url.startsWith('https://')
      );

      if(isTemplate) {
        return config;
      }

      if(token && Util.isSameOrigin(config.url)) {
        config.headers.Authorization = 'Bearer ' + token;
      }
      return config;
    },

    // Intercept 401s and redirect you to login
    responseError(response) {
      if(response.status === 401) {
        state = state || $injector.get('$state');
        var currentState = state.current.name;

        // remove any stale tokens
        $cookies.remove('token');

        // redirect if not on login page
        if(currentState.indexOf('login') < 0
            && currentState.indexOf('oauth') < 0) {
          state.go('login');
        }
      }
      return $q.reject(response);
    }
  };
}

// Explicit annotation for Angular's dependency injection
authInterceptor.$inject = ['$rootScope', '$q', '$cookies', '$injector', 'Util'];
